
import React from "react";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";
import { Link } from "lucide-react";

interface DocumentLinkFieldProps {
  element: FormFieldType;
  documentUrls: string[];
}

export const DocumentLinkField: React.FC<DocumentLinkFieldProps> = ({ element, documentUrls }) => {
  return (
    <FieldWrapper element={element}>
      <div className="space-y-2">
        <p className="text-sm font-medium text-green-600">
          หัวข้อนี้มีชีทอยู่แล้วไม่ต้องอัปโหลด
        </p>
        
        <ul className="list-disc pl-5 text-sm space-y-1">
          {documentUrls.map((url, index) => (
            <li key={index} className="flex items-center">
              <Link className="h-4 w-4 mr-2" />
              <a 
                href={url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-600 hover:underline"
              >
                เอกสารชีท {index + 1}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </FieldWrapper>
  );
};

export default DocumentLinkField;
